module.exports = __webpack_public_path__ + "img/icon-ghost-white.png";


//////////////////
// WEBPACK FOOTER
// ./source/assets/img/icon-ghost-white.png
// module id = 1024
// module chunks = 0